import React from "react";

import AddNewPlant from "./pages/addNewPlant";
import Home from "./pages/appHome";
import PlantPage from "./pages/plantPage";
import RoAdvisorHome from "./pages/home";
import LifetimeAdvisorHome from "./pages/lifetimeAdvisorHome";
import AnalyseData from "./pages/analyseData";
import { Routes, Route } from "react-router-dom";

import { updatePlantId } from "./utils/Utils";
import { API_URLS } from "./network/appUrls";
import NotAuthorized from "./pages/unauthorized";
import RequestAccess from "./pages/requesAccessPage";
import MessagePage from "./pages/messageDisplayPage";
import AdminPage from "./pages/AdminPortal";
import UserPage from "./pages/AdminPortal/userManage";

const searchParams = new URLSearchParams(window.location.search);
const plantId = searchParams.get("plantId");
updatePlantId(plantId);

console.log("routes", "routesFile");

export const AppRoutes = () => {
  // const isLocalhost = window.location.hostname === "localhost";
  const basePath = API_URLS.basePath; //isLocalhost ? "/" : window.location.origin;

  return (
    <Routes>
      <Route
        path={`${basePath}cleaningAdvisorHome`}
        element={<RoAdvisorHome />}
      />
      <Route
        path={`${basePath}lifetimeAdvisorHome`}
        element={<LifetimeAdvisorHome />}
      />
      <Route path={`${basePath}home`} element={<Home />} />
      <Route path={`${basePath}plant`} element={<PlantPage />} />
      <Route path={`${basePath}addPlant`} element={<AddNewPlant />} />
      <Route path={`${basePath}editPlant`} element={<AddNewPlant />} />
      <Route path={`${basePath}analyseData`} element={<AnalyseData />} />
      <Route path={`${basePath}`} element={<PlantPage />} />
      <Route path={`${basePath}unauthorized`} element={<NotAuthorized />} />
      <Route path={`${basePath}requestAccess`} element={<RequestAccess />} />
      <Route path={`${basePath}messagePage`} element={<MessagePage />} />
      <Route path={`${basePath}admin-portal`} element={<AdminPage />} />
      <Route path={`${basePath}user-management`} element={<UserPage />} />
    </Routes>
  );
};

// const APP_ROUTES = [
//   {
//     path: `/`,
//     element: <RootLayout />,
//     children: [
//       {
//         path: `cleaningAdvisorHome`,
//         element: <RoAdvisorHome />,
//       },
//       {
//         path: `lifetimeAdvisorHome`,
//         element: <LifetimeAdvisorHome />,
//       },

//       {
//         path: `home`,
//         element: <Home />,
//       },

//       {
//         path: `plant`,
//         element: <PlantPage />,
//         exact: true,
//       },
//       {
//         path: `addPlant`,
//         element: <AddNewPlant />,
//         exact: true,
//       },
//       {
//         path: `editPlant`,
//         element: <AddNewPlant />,
//         exact: true,
//       },
//       {
//         path: `analyseData`,
//         element: <AnalyseData />,
//         exact: true,
//       },
//     ],
//   },
// ];
// export default APP_ROUTES;
